import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMK8008Bloo = () => (
  <ArticleWrapper articleId="gmk_8008_bloo">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK 8008 Bloo</h1>
        {/* Add your GMK 8008 Bloo article content here */}
        <p>This is a placeholder article for the GMK 8008 Bloo keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMK8008Bloo;
